import { useState } from 'react';

const FAQFamily = () => {
    const faqs = [
        {
          question: "What are the best destinations for a family holiday?",
          answer: "That depends on what kind of adventure your family is seeking! For beach lovers, the Caribbean islands, Hawaii, and Florida offer endless fun in the sun. If you're looking for theme park thrills, Orlando and California are top contenders. For a cultural experience, consider Europe, with cities like London, Paris, and Rome offering kid-friendly museums and historical sites. And for nature lovers, national parks like Yellowstone and Yosemite provide unforgettable outdoor adventures."
        },
        {
          question: "What should we consider when choosing a family-friendly hotel or resort?",
          answer: "Look for places with amenities that cater to families, such as kids' clubs with supervised activities, swimming pools with splash zones, playgrounds, and spacious rooms or suites. Some resorts even offer babysitting services, giving parents a chance to relax and enjoy some adult time."
        },
        {
          question: "How can we keep our kids entertained on a long flight?",
          answer: "Ah, the eternal struggle! Pack plenty of snacks, books, games, and electronic devices loaded with movies and shows. Consider bringing small, new toys to surprise them with during the flight. And don't underestimate the power of a good old-fashioned deck of cards or travel-sized board games."
        },
        {
          question: "What are some tips for planning a stress-free family holiday?",
          answer: "Involve your kids in the planning process to get them excited and ensure their interests are considered. Pack light to avoid baggage headaches. Build in downtime for relaxation and avoid over-scheduling your itinerary. Most importantly, be flexible and go with the flow! Things don't always go as planned, but that's part of the adventure."
        },
        {
          question: "Are there any destinations that are particularly good for multigenerational family trips?",
          answer: "Absolutely! Cruises are a great option, offering something for everyone, from kids' clubs and water slides to adult-only pools and fine dining. National parks are also fantastic for multigenerational trips, with a range of activities like hiking, biking, and wildlife viewing. And consider destinations with a mix of activities, like Hawaii, which offers beaches, volcanoes, cultural experiences, and historical sites."
        }
      ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="mt-8 px-4 md:px-0">
      <h2 className="text-2xl font-semibold mb-4">FAQs</h2>
      {faqs.map((faq, index) => (
        <div key={index} className="mb-4 lg:w-[900px]">
          <div
            className={`cursor-pointer py-4 px-4 bg-white rounded-lg shadow-sm border border-light hover:shadow-md transition-shadow ${activeIndex === index ? 'pb-8' : ''}`}
            onClick={() => toggleAccordion(index)}
          >
            <div className="flex justify-between items-center">
              <h3 className="text-base md:text-lg font-medium w-[90%]">{faq.question}</h3>
              <svg
                className={`w-8 h-8 transition-transform duration-300 p-1 rounded-full text-halo-pink hover:bg-halo-pink hover:text-white focus:outline-none ${activeIndex === index ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {activeIndex === index && (
              <p className="mt-3 text-gray-700">{faq.answer}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQFamily;
